import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { IBenefitType } from '@/common/types/general';

export const benefitTypeSlugMapping: Record<IBenefitType, IMenhirBenefitSlug> =
  {
    childcare_voucher: 'childcare-voucher',
    education_training: 'education-training',
    gym_fitness: 'gym-fitness',
    health_wellbeing: 'health-wellbeing',
    professional_training: 'professional-training',
    retirement_investment: 'retirement-investment',
    senior_expenses: 'senior-expenses',
    technology: 'technology',
    transportation: 'transportation',
    parking: 'parking',
    summer_camp: 'summer-camp',
    donation: 'donation',
    other_benefits: 'other-benefits',
    cashout: 'cashout',
    fringe: 'fringe',
    recreation: 'recreation',
    family_care_services: 'family-care-services',
    it_education: 'it-education',
    it_transportation: 'it-transportation',
    pension_funds: 'pension-funds',
    meals: 'meals',
    es_public_transport: 'es-public-transport',
    es_childcare: 'es-childcare',
  };

export const benefitRouteTypeMapping: Record<string, IBenefitType> = {
  'health-wellbeing': 'health_wellbeing',
  'gym-fitness': 'gym_fitness',
  'education-training': 'education_training',
  'senior-expenses': 'senior_expenses',
  technology: 'technology',
  transportation: 'transportation',
  'professional-training': 'professional_training',
  parking: 'parking',
  'summer-camp': 'summer_camp',
  'other-benefits': 'other_benefits',
  'retirement-investment': 'retirement_investment',
  'childcare-voucher': 'childcare_voucher',
  donation: 'donation',
  recreation: 'recreation',
  fringe: 'fringe',
  'it-education': 'it_education',
  'it-transportation': 'it_transportation',
  'family-care-services': 'family_care_services',
  'pension-funds': 'pension_funds',
};
